var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emotivi-app container-lg p-0", attrs: { id: "app" } },
    [
      _c("div", { staticClass: "d-flex flex-row" }, [
        _vm.isLogged && !_vm.isPublicPage
          ? _c(
              "div",
              {
                staticClass: "offcanvas-lg offcanvas-start",
                attrs: {
                  "data-bs-scroll": "true",
                  tabIndex: "{-1}",
                  id: "offcanvasMenu",
                  "aria-labelledby": "offcanvasMenuLabel"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "sticky-top vh-100" },
                  [_c("LeftMenu")],
                  1
                )
              ]
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "d-flex flex-grow-1 flex-column page-content",
            class: { logged: _vm.isLogged }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "page-header sticky-top d-flex flex-row navbar navbar-light ps-2 pe-2 pb-2",
                attrs: { "data-scroll": "0" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex-grow-1 align-content-center",
                    class: { "d-lg-none": !_vm.isPublicPage }
                  },
                  [
                    _vm.$store.state.authenticated &&
                    _vm.$store.state.affiliatedUser.establishments[0].es_avatar
                      ? _c("img", {
                          staticClass: "company-logo-mobile",
                          attrs: {
                            src:
                              "" +
                              this.$config.server_url +
                              _vm.$store.state.affiliatedUser.establishments[0]
                                .es_avatar,
                            alt: ""
                          }
                        })
                      : _c("img", {
                          staticClass: "company-logo-mobile",
                          attrs: { src: "/images/logo_emotivi.png", alt: "" }
                        })
                  ]
                ),
                _vm.isLogged && !_vm.isPublicPage
                  ? _c("div", { staticClass: "d-flex align-items-center" }, [
                      _vm._m(0)
                    ])
                  : _vm._e()
              ]
            ),
            _c(
              "div",
              { staticClass: "flex-grow-1 ps-2 pe-2", attrs: { id: "app" } },
              [_c("router-view")],
              1
            )
          ]
        ),
        _vm._m(1)
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "navbar-toggler d-lg-none",
        attrs: {
          type: "button",
          "data-bs-toggle": "offcanvas",
          "data-bs-target": "#offcanvasMenu",
          "aria-controls": "offcanvasMenu"
        }
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "none" }, attrs: { id: "wincookie" } },
      [
        _c(
          "div",
          {
            staticStyle: {
              float: "left",
              cursor: "pointer",
              "margin-right": "20px"
            }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  href: "javascript:void(0);",
                  onclick: "closeCookieWin();"
                }
              },
              [_c("img", { attrs: { src: "/images/bt_fermer.png", alt: "" } })]
            )
          ]
        ),
        _vm._v(
          " En poursuivant votre navigation sans modifier vos paramètres, vous acceptez l'utilisation des cookies ou technologies similaires pour disposer de services et d'offres adaptés à vos centres d'intérêts ainsi que pour la sécurisation des transactions sur notre site. Pour plus d'informations, "
        ),
        _c("a", { attrs: { href: "/files/CGU-Emotivi-20201209.pdf" } }, [
          _vm._v("cliquez ici")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }